/**
 * Tarjeta esquina cuando no hay FAB CRM: envoltorio visual mínimo alrededor de la **misma**
 * sesión de llamada que el marcador (`CallCenterPhoneActiveSession` surface `corner`).
 */

import { Box } from '@/lib/polaris';
import { CallCenterPhoneActiveSession } from '@/components/callCenter/CallCenterPhoneActiveSession';
import type { WebrtcCallUiPhase } from '@/lib/telnyxCallState';

interface Props {
  tenantId: string;
  crmCallId?: string | null;
  crmCallStatus?: string | null;
  remotePhone: string | null;
  callPhase: WebrtcCallUiPhase;
  callDirection: 'inbound' | 'outbound' | null;
  elapsedSeconds: number;
  onHangup: () => void;
  onOpenDialer: () => void;
  hangingUp: boolean;
  isMuted?: boolean;
  isOnHold?: boolean;
  onToggleMute?: () => void;
  onToggleHold?: () => void;
  onTransfer?: (transferTo: string) => Promise<{ success: boolean; message?: string }>;
  onWarmTransfer?: (action: 'initiate' | 'complete' | 'cancel', transferTo?: string) => Promise<{ success: boolean; message?: string }>;
  warmTransferActive?: boolean;
  isRecordingPaused?: boolean;
  onToggleRecordingPause?: () => void;
}

export function CallCenterActiveCallCard(props: Props) {
  return (
    <Box padding="0" shadow="500" borderRadius="300" overflow="hidden" maxWidth="min(480px, calc(100vw - 32px))" width="100%">
      <CallCenterPhoneActiveSession {...props} surface="corner" />
    </Box>
  );
}

export default CallCenterActiveCallCard;
